module.exports = __webpack_public_path__ + "img/ImokempiEmail.a1de5efd.png";